import { StateNode, Vec, clamp, last } from "@tldraw/editor";
class OneFingerZooming extends StateNode {
  static id = "one_finger_zooming";
  anchorScreenPoint = new Vec();
  initialCamera = new Vec();
  initialZoom = 1;
  originScreenY = 0;
  onEnter(_info) {
    const camera = this.editor.getCamera();
    this.initialCamera = Vec.From(camera);
    this.initialZoom = camera.z;
    this.anchorScreenPoint = this.editor.inputs.getOriginScreenPoint().clone();
    this.originScreenY = this.editor.inputs.getCurrentScreenPoint().y;
    this.editor.setCursor({ type: "grab", rotation: 0 });
  }
  onPointerMove(_info) {
    this.editor.menus.clearOpenMenus();
    const currentScreenY = this.editor.inputs.getCurrentScreenPoint().y;
    const dy = (this.originScreenY - currentScreenY) * -1;
    const zoomFactor = Math.pow(2, dy / 200);
    const newZoom = this.clampZoom(this.initialZoom * zoomFactor);
    const { x: cx, y: cy } = this.initialCamera;
    const { x: sx, y: sy } = this.anchorScreenPoint;
    this.editor.setCamera(
      new Vec(
        cx + sx / newZoom - sx / this.initialZoom,
        cy + sy / newZoom - sy / this.initialZoom,
        newZoom
      ),
      { immediate: true }
    );
  }
  onPointerUp(_info) {
    this.complete();
  }
  onCancel() {
    this.parent.transition("idle");
  }
  onInterrupt() {
    this.parent.transition("idle");
  }
  complete() {
    const pointerVelocity = this.editor.inputs.getPointerVelocity();
    const velocityAtPointerUp = Math.min(pointerVelocity.len(), 2);
    if (velocityAtPointerUp > 0.1) {
      this.editor.slideCamera({
        speed: velocityAtPointerUp,
        direction: { x: 0, y: 0, z: Math.sign(pointerVelocity.y) * 0.01 }
      });
    }
    this.parent.transition("idle");
  }
  clampZoom(zoom) {
    const { zoomSteps } = this.editor.getCameraOptions();
    const baseZoom = this.editor.getBaseZoom();
    const zoomMin = zoomSteps[0] * baseZoom;
    const zoomMax = last(zoomSteps) * baseZoom;
    return clamp(zoom, zoomMin, zoomMax);
  }
}
export {
  OneFingerZooming
};
//# sourceMappingURL=OneFingerZooming.mjs.map
